import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

export type TCharacteristicsProps = {
    title: string,
    value: string,

    Component?: (props: any) => JSX.Element,
    componentProps?: any,
};

const Characteristics = ({
    title,
    value,

    Component = Paragraph4,
    componentProps,

    ...props
}: TCharacteristicsProps): JSX.Element => {
    return (
        <div {...props}>
            <Component {...componentProps} as={'span'}>{title}</Component>
            <div/>
            <Component {...componentProps} as={'span'}>{value}</Component>
        </div>
    );
};

export default Characteristics;
